export const constants = {
	VC_CLASS_POSTFIX: 'vc'
};
